// @ts-nocheck

// See: https://github.com/webmonitoring/visualping.io/blob/953fb0b8e5455f46d3b7142ab2f6119253f37f81/public/externalfiles/widget/vp.js

export const createWidget = (options) => {
  var vpContainer = document.getElementById(options.widgetId);
  var vpInnerBox = document.createElement("div");
  var bg = vpContainer.dataset.bg;
  var mode = vpContainer.dataset.mode;
  var btn = vpContainer.dataset.btn.split(",");
  var trigger = vpContainer.dataset.trigger;
  var compare = vpContainer.dataset.compare;
  var crop = vpContainer.dataset.crop;
  var websiteUrl = vpContainer.dataset.url;
  var label = vpContainer.dataset.label;

  var bgColor = {
    white: "#ffffff",
    light: "#f1f4f9",
    transparent: "transparent",
    fordark: "transparent",
  }[vpContainer.dataset.bg];

  var font = "'Segoe UI', Roboto, Arial, Helvetica, Verdana, Tahoma, sans-serif";

  var logo = `<svg fill="none" viewBox="0 0 125 21" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10.5" fill="#1882ff" r="10"/><g fill="${
    bg === "fordark" ? "#e3e5eb" : "#333"
  }"><path clip-rule="evenodd" d="m19.96 11.38a10.15 10.15 0 0 0 .02-1.54l-3.71.78-3.13-2.66a.75.75 0 0 0 -1.18.3l-1.71 4.4-1.98-7.73a.75.75 0 0 0 -1.38-.19l-2.62 4.63h-4.2a10.1 10.1 0 0 0 -.06 1.5h4.7c.27 0 .52-.15.65-.38l1.92-3.39 2.1 8.2a.75.75 0 0 0 1.42.09l2.17-5.6 2.6 2.21c.18.15.42.21.65.16z" fill="#fff" fill-rule="evenodd"/><path d="m32.08 15.83h2.49l4.27-10.51h-2.61l-1.87 4.83c-.43 1.13-.8 2.23-.95 2.91a32.2 32.2 0 0 0 -.91-2.91l-1.76-4.83h-2.74zm9.62-12.66c.83 0 1.51-.68 1.51-1.55 0-.85-.68-1.53-1.51-1.53-.85 0-1.5.68-1.5 1.53 0 .87.65 1.55 1.5 1.55zm-1.27 12.66h2.53v-10.51h-2.53zm4.47-3.15c.09 2.09 1.67 3.43 4.11 3.43 2.4 0 4.04-1.32 4.04-3.37 0-1.5-.91-2.53-2.59-2.95l-1.8-.45c-.77-.21-1.29-.49-1.29-1.17 0-.72.56-1.23 1.47-1.23.96 0 1.58.55 1.58 1.46h2.3c-.08-2.08-1.6-3.4-3.81-3.4-2.2 0-3.84 1.32-3.84 3.32 0 1.36.77 2.49 2.74 3.02l1.78.47c.66.19 1.08.5 1.08 1.1 0 .83-.77 1.22-1.7 1.22-1.12 0-1.76-.53-1.76-1.45zm14.02 3.42c1.39 0 2.71-.65 3.31-1.63l.17 1.36h2.36v-10.51h-2.53v5.51c0 1.9-.7 2.96-2.36 2.96-1.28 0-2.18-.64-2.18-2.81v-5.66h-2.52v6.57c0 2.51 1.32 4.22 3.75 4.22zm11.58 0c1.61 0 2.83-.74 3.27-1.82l.19 1.55h2.21v-6.38c0-2.79-1.57-4.45-4.45-4.45-2.65 0-4.48 1.51-4.46 3.77h2.16c-.02-1.09.78-1.75 2.17-1.75 1.25 0 2.12.55 2.12 2v.24l-2.92.23c-2.3.2-3.8 1.3-3.8 3.34 0 1.96 1.3 3.28 3.5 3.28zm.82-1.95c-1.14 0-1.76-.51-1.76-1.43 0-.85.54-1.36 2.03-1.5l2.14-.2v.55c0 1.96-1.33 2.58-2.4 2.58zm10.01 1.68v-15.83h-2.52v15.83zm2.94 4.87h2.47v-6.32c.64 1.09 2.03 1.73 3.56 1.73 3.03 0 4.83-2.39 4.79-5.66-.06-3.3-1.9-5.45-4.81-5.45-1.55 0-2.96.7-3.59 1.91l-.14-1.6h-2.28zm2.57-10.13c0-1.89 1.12-3.2 2.88-3.2s2.82 1.33 2.82 3.2c0 1.88-1.06 3.2-2.82 3.2s-2.88-1.3-2.88-3.2zm11.58-7.4c.83 0 1.52-.68 1.52-1.55 0-.85-.69-1.53-1.52-1.53-.85 0-1.49.68-1.49 1.53 0 .87.64 1.55 1.5 1.55zm-1.26 12.66h2.53v-10.51h-2.53zm7.89 0v-5.66c0-2.2 1.41-2.8 2.51-2.8.87 0 2.16.35 2.16 2.6v5.86h2.5v-6.47c0-2.62-1.2-4.36-3.87-4.36-1.4 0-2.61.6-3.28 1.68l-.2-1.36h-2.34v10.51zm9.25-5.49c0 3.06 1.93 5.28 4.82 5.28 1.49 0 2.77-.62 3.41-1.64v1.79c0 1.72-1.05 2.87-2.81 2.87-1.58 0-2.66-.79-2.8-2.17h-2.55a4.98 4.98 0 0 0 5.2 4.53c3.32 0 5.43-2.23 5.43-5.7v-9.98h-2.24l-.14 1.42c-.63-1.1-1.91-1.76-3.42-1.76-2.93 0-4.9 2.28-4.9 5.36zm2.58-.06c0-1.75 1.07-3.02 2.67-3.02 1.74 0 2.9 1.3 2.9 3.02 0 1.74-1.16 3.08-2.9 3.08-1.57 0-2.67-1.32-2.67-3.08z"/></g></svg>`;
  var elems = [
    {
      elem: "div",
      style: {
        fontSize: "11px",
        fontWeight: 600,
        color: bg === "fordark" ? "#ffffff" : "rgb(152, 153, 155)",
        letterSpacing: "0.4px",
        textAlign: "center",
        lineHeight: "13px",
        fontFamily: font,
      },
      text: "Be notified when this page changes",
    },
    {
      elem: "div",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: mode === "medium" ? "column" : "row",
        padding: "8px 0",
        boxSizing: "border-box",
      },
      childElems: [
        {
          elem: "input",
          style: {
            width: "100%",
            height: "auto",
            flex: 1,
            margin: "0",
            padding: "10px 8px 9px",
            fontSize: mode === "small" ? "12px" : "13px",
            textAlign: mode === "small" ? "left" : "center",
            lineHeight: "1.5",
            color: "#333333",
            border: "1px solid rgb(229, 233, 241)",
            borderRadius: mode === "small" ? "8px 0 0 8px" : "8px",
            backgroundColor: bg === "white" ? "rgb(247, 248, 251)" : "#ffffff",
            transition: "border 0.2s ease",
            outline: "none",
            boxSizing: "border-box",
            fontFamily: font,
          },
          attr: {
            id: "visualpingWidgetEmailInput",
            placeholder: "email@example.com",
            autocomplete: "off",
            onfocus: "this.style.borderColor = 'rgb(24, 130, 255)'",
            onblur: "this.style.borderColor = 'rgb(229, 233, 241)'",
          },
        },
        {
          elem: "button",
          style: {
            width: mode === "small" ? "auto" : "100%",
            height: "auto",
            margin: mode === "small" ? "0" : "6px 0 0 0",
            padding: "10px",
            backgroundColor: btn[0],
            color: btn[1],
            border: "none",
            borderRadius: mode === "small" ? "0 8px 8px 0" : "8px",
            lineHeight: "1.5",
            fontSize: "13px",
            fontWeight: 600,
            letterSpacing: "0.4px",
            transition: "opacity 0.2s ease",
            boxSizing: "border-box",
            whiteSpace: "nowrap",
            cursor: "pointer",
            fontFamily: font,
          },
          text: label,
          attr: {
            id: "visualpingWidgetSubmitButton",
            onmouseover: "this.style.opacity = 0.8",
            onmouseout: "this.style.opacity = 1",
          },
        },
      ],
    },
    {
      elem: "div",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      childElems: [
        {
          elem: "div",
          style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: mode === "small" ? "220px" : "100%",
            boxSizing: "border-box",
          },
          childElems: [
            {
              elem: "span",
              style: {
                margin: "0 12px 3px 0",
                fontSize: "9px",
                color: "rgb(160, 162, 167)",
                fontFamily: "'Segoe UI', Roboto, Arial, Helvetica, Verdana, Tahoma, sans-serif",
              },
              html: 'We keep your email <a href="https://visualping.io/terms" style="color: inherit; text-decoration: underline;">private</a>',
            },
            {
              elem: "a",
              style: { width: "76px", height: "14px" },
              attr: { href: "https://visualping.io" },
              html: logo,
            },
          ],
        },
      ],
    },
  ];
  Object.assign(vpInnerBox.style, {
    maxWidth: "300px",
    padding: mode === "small" ? "7px 10px" : "10px",
    backgroundColor: bgColor,
    border: "1px solid",
    borderColor: bg === "white" || bg === "light" ? "rgb(229, 233, 241)" : "transparent",
    borderRadius: "12px",
    boxSizing: "border-box",
  });
  vpContainer.appendChild(vpInnerBox);

  for (var i = 0; i < elems.length; i++) {
    buildElem(elems[i], vpInnerBox);
  }

  function buildElem(elem, parent) {
    var el = document.createElement(elem.elem);
    var childs = elem.childElems;
    var attr = elem.attr;
    if (elem.style) Object.assign(el.style, elem.style);
    if (elem.text) el.innerText = elem.text;
    if (elem.html) el.innerHTML = elem.html;
    if (attr) {
      for (var prop in attr) {
        el.setAttribute(prop, attr[prop]);
      }
    }
    if (childs) {
      for (var i = 0; i < childs.length; i++) {
        buildElem(childs[i], el);
      }
    }
    parent.appendChild(el);
  }

  document.getElementById("visualpingWidgetSubmitButton").addEventListener("click", onSubmit);

  function gotoVp(email) {
    var url = websiteUrl ? websiteUrl : window.btoa(window.location.href);
    window.open(
      `https://visualping.io/?url=${url}&mode=${compare}&trigger=${trigger}&precrop=${crop}&email=${email}&sref=uwgt`
    );
  }

  function onSubmit() {
    var emailField = document.getElementById("visualpingWidgetEmailInput");
    var email = emailField.value;
    if (email.length > 6 && ValidateEmail(email)) {
      gotoVp(email);
    } else {
      emailField.style.borderColor = "red";
    }
  }

  function ValidateEmail(inputText) {
    var mailformat =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (mailformat.test(inputText)) {
      return true;
    } else {
      return false;
    }
  }
};

export const destoryWidget = (options) => {
  var vpContainer = document.getElementById(options.widgetId);

  vpContainer?.replaceChildren([]);
};
